module.exports = __webpack_public_path__ + "static/media/Impreza-GJ-Sedan-WRX-STi.cf701acf.jpg";